'use client';

import { Box, Container, Typography } from '@mui/material';

import { Product } from '../../../services/types/product';
import ProductGrid from '../ProductGrid';

export interface RelatedProductsSectionProps {
  products: Product[];
  title?: string;
}

const RelatedProductsSection = ({
  products,
  title = 'Sản phẩm liên quan',
}: RelatedProductsSectionProps) => {
  if (!products || products.length === 0) {
    return null;
  }

  return (
    <Box sx={{ py: 6, backgroundColor: 'white' }}>
      <Container maxWidth='lg'>
        <Typography
          variant='h4'
          component='h2'
          sx={{
            fontWeight: 700,
            color: '#1A1A1A',
            marginBottom: 4,
            textAlign: 'center',
            fontSize: { xs: '1.75rem', md: '2.125rem' },
          }}
        >
          {title}
        </Typography>

        <ProductGrid products={products} variant='compact' />
      </Container>
    </Box>
  );
};

export default RelatedProductsSection;
